// extracted by mini-css-extract-plugin
module.exports = {"ImageText1":"budgetCard_ImageText1__2moCb","ImageText2":"budgetCard_ImageText2__1iha9","ShopOnBudgetImage":"budgetCard_ShopOnBudgetImage__1-Mcs"};